const logotext = "Will Sands";
const meta = {
    title: "Will Sands - French Horn",
    description: "Musician, Performer, Teacher",
};

const introdata = {
    title: "Will Sands - French Horn",
    animated: {
        first: "Musician",
        second: "Performer",
        third: "Teacher",
    },
    description: "",
};

// ─── Bio ─────────────────────────────────────────────────────────────────────
const dataabout = {
    title: "Biography",
    aboutme: 'Hornist Will Sands brings what Seen and Heard International has praised as "a rich, honeyed tone" and a gift for "combining sincerity and tonal luster" to a career on the orchestral and chamber stages. A 2025–2027 fellow of Ensemble Connect — the program of Carnegie Hall, The Juilliard School, and the Weill Music Institute — he performs throughout New York and across the country.\nAs an orchestral player, Sands has appeared with the New World Symphony, the Portland Symphony Orchestra, the Buffalo Philharmonic, and the symphonies of Harrisburg and Syracuse. He is also a dedicated chamber musician: as a member of A Yale Horn Quartet, he took first prize in the collegiate division at the 2025 International Horn Symposium.\nSands holds a Bachelor of Music with Distinction from the Eastman School of Music and both a Master of Music and a Master of Musical Arts from the Yale School of Music, where he received the John Swallow Brass Prize. His principal teachers include William Purvis, W. Peter Kurau, and Robert Lauver. A native of Pittsburgh, he began playing the horn at the age of eight.',
};

// ─── Press Quotes ────────────────────────────────────────────────────────────
// Each entry: { quote: "...", publication: "..." }
const pressQuotes = [
    {
        quote: "Sands was terrific, combining sincerity and tonal luster in the piece's best melody.",
        publication: "Seen and Heard International",
    },
];

// ─── Upcoming Performances ───────────────────────────────────────────────────
// Each entry: { title: "...", venue: "...", date: "Month Day, Year" }
// Example:
// { title: "Horn Recital", venue: "Carnegie Hall, New York", date: "July 4, 2026" },
const upcomingPerformances = [
];

// ─── Experience / Timeline ───────────────────────────────────────────────────
// Each entry: { jobtitle: "...", where: "...", date: "Year or Year–Year" }
const worktimeline = [
    {
        jobtitle: "Performing Fellow",
        where: "Ensemble Connect - Carnegie Hall",
        date: "2025 - Present",
    },
    {
        jobtitle: "MMA",
        where: "Yale School of Music",
        date: "2024-2025",
    },
    // {
    //     jobtitle: "Full Stack Software Engineer",
    //     where: "Gumband",
    //     date: "2023-2025",
    // },
    // {
    //     jobtitle: "Finalist, Runner Up",
    //     where: "The Syracuse Orchestra 3rd Horn/Utility Audition",
    //     date: "2025",
    // },
    // {
    //     jobtitle: "Semi-Finalist",
    //     where: "The Philadelphia Orchestra Asst Principal Horn Audition",
    //     date: "2025",
    // },
    // {
    //     jobtitle: "Substitute Horn",
    //     where: "New World Symphony",
    //     date: "2024",
    // },
    // {
    //     jobtitle: "Finalist",
    //     where: "Virginia Symphony 3rd Horn/Associate Principal",
    //     date: "2024",
    // },
    {
        jobtitle: "MM",
        where: "Yale School of Music",
        date: "2022-2024",
    },
    // {
    //     jobtitle: "Substitute Horn",
    //     where: "Harrisburg Symphony",
    //     date: "2023-Present",
    // },
    // {
    //     jobtitle: "Runner Up",
    //     where: "West Point Band 2nd Horn Audition",
    //     date: "2023",
    // },
    // {
    //     jobtitle: "Finalist",
    //     where: "Harrisburg Symphony Asst. Principal Horn Audition",
    //     date: "2023",
    // },
    // {
    //     jobtitle: "Semi-Finalist",
    //     where: "Harrisburg Symphony 2nd Horn Audition",
    //     date: "2023",
    // },
    // {
    //     jobtitle: "Substitute Horn",
    //     where: "Symphoria",
    //     date: "2022-Present",
    // },
    // {
    //     jobtitle: "Substitute Horn",
    //     where: "Buffalo Philharmonic",
    //     date: "2022-2023",
    // },
    {
        jobtitle: "Bachelor of Music (with Distinction)",
        where: "Eastman School of Music",
        date: "2018-2022",
    },
    {
        jobtitle: "Bachelor of Science - Computer Science (magna cum laude)",
        where: "University of Rochester",
        date: "2018-2022",
    },
];

// ─── Portfolio Videos ─────────────────────────────────────────────────────────
// To add a video, paste the YouTube video ID from the URL:
//   youtube.com/watch?v=XXXXXXXXXXX  →  youtubeId: "XXXXXXXXXXX"
// Each entry: { youtubeId: "...", title: "optional label" }
const dataportfolio = [
    { youtubeId: "NQAe0MERVcM", title: "" },
    { youtubeId: "pPj0tBg7V54", title: "" },
    { youtubeId: "Ci190xR4R0c", title: "" },
];

// ─── Contact ──────────────────────────────────────────────────────────────────
const contactConfig = {
    YOUR_EMAIL: "will.sands.v@gmail.com",
    YOUR_FONE: "(412)-608-6516",
    description: "Feel free to reach out regarding lessons, engagements, performances, or any other questions you might have, or contact me directly via phone or email.",
    YOUR_SERVICE_ID: "service_8cn2pil",
    YOUR_TEMPLATE_ID: "template_m2d9nad",
    YOUR_USER_ID: "-MpIMf8hbUqJLzc9E",
};

// ─── Social Links ─────────────────────────────────────────────────────────────
const socialprofils = {
    linkedin: "https://www.linkedin.com/in/whsands/",
    facebook: "https://www.facebook.com/wsands1701",
    instagram: "https://www.instagram.com/wsands_music/",
};

export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    upcomingPerformances,
    pressQuotes,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
